(() => {
  if (window.AxioSizeGuideInitialized) return;

  window.AxioSizeGuideInitialized = true;

  const getDialog = (trigger) => {
    const dialogId = trigger?.dataset?.dialogId;

    if (!dialogId) return null;

    return document.getElementById(dialogId);
  };

  const openDialog = (dialog) => {
    if (!dialog || dialog.open) return;

    if (typeof dialog.showModal === 'function') {
      dialog.showModal();
    } else {
      dialog.setAttribute('open', '');
    }

    document.documentElement.classList.add('axio-size-guide-is-open');

    const panel = dialog.querySelector(
      '.axio-size-guide-dialog__panel'
    );

    if (panel) {
      panel.scrollTop = 0;
    }
  };

  const closeDialog = (dialog) => {
    if (!dialog) return;

    if (typeof dialog.close === 'function' && dialog.open) {
      dialog.close();
    } else {
      dialog.removeAttribute('open');
    }

    document.documentElement.classList.remove(
      'axio-size-guide-is-open'
    );
  };


  document.addEventListener('click', (event) => {

    const openButton = event.target.closest(
      '[data-axio-size-guide-open]'
    );

    if (openButton) {
      event.preventDefault();

      const dialog = getDialog(openButton);

      openDialog(dialog);

      return;
    }


    const closeButton = event.target.closest(
      '[data-axio-size-guide-close]'
    );

    if (closeButton) {
      event.preventDefault();

      const dialog = closeButton.closest(
        '.axio-size-guide-dialog'
      );

      closeDialog(dialog);

      return;
    }


    const dialog = event.target.closest(
      '.axio-size-guide-dialog'
    );

    if (
      dialog &&
      event.target === dialog
    ) {
      closeDialog(dialog);
    }

  });


  document.addEventListener(
    'close',
    (event) => {

      if (
        event.target.matches?.(
          '.axio-size-guide-dialog'
        )
      ) {
        document.documentElement.classList.remove(
          'axio-size-guide-is-open'
        );
      }

    },
    true
  );


  document.addEventListener(
    'cancel',
    (event) => {

      if (
        event.target.matches?.(
          '.axio-size-guide-dialog'
        )
      ) {
        document.documentElement.classList.remove(
          'axio-size-guide-is-open'
        );
      }

    },
    true
  );

})();